export default defineI18nLocale(() => {
  return {
    home: {
      openFinance: 'Open Finance',
      description:
        '가스비 없이 빠르고 안전하게, 기관급 유동성과 함께하는 온체인 거래의 새로운 기준',
      gasFees: '가스비',
      whyHelix: '왜 Helix인가요?',
      reimagined: 'Reimagined',
      latestNews: '최신 소식',
      totalVolume: '총 거래량',
      totalMarkets: '전체 마켓',
      startTrading: '트레이딩 시작하기',
      helixDocs: 'Helix 문서',
      somethingIsBrewing: '무언가가 준비되고 있어요',
      builtForTheCommunity: '커뮤니티를 위한 설계',
      builtForTheCommunityDescription: '투자자, VC 그리고 내부자없음',
      downloadHelixMobile:
        'IOS 또는 Android용 Helix 모바일 앱을 다운로드하세요',
      overview: {
        title: '왜 Helix인가요?',
        lpRewardsTitle: 'LP 보상',
        tradingBotsTitle: '트레이딩 봇',
        gasFreeTitle: '가스비 없는 거래',
        tradeStocksTitle: '주식 및 RWA 거래',
        lpRewardsDescription: '유동성을 제공하고 그에 대한 보상을 받으세요.',
        description:
          '최고 수준의 거래소와 같이 설계되었지만, 완전히 탈중앙화되었습니다.',
        gasFreeDescription: 'Helix에선 가스비 걱정을 하지 않아도 됩니다.',
        tradingBotsDescription:
          '높은 수준의 스마트 온체인 트레이딩 전략을 클릭 한 번으로 실행해보세요.',
        tradeStocksDescription:
          '암호화폐로 주식 및 실물 자산(RWA)을 더 빠르고 저렴하며 투명하게 거래해보세요.'
      },
      gettingStarted: {
        title: 'Helix 시작하기',
        injectiveBridge: 'Injective 브릿지',
        description: 'Injective에 크립토 자산을 입금하세요',
        description2:
          '{bridgeLink}를 통해 USDT 및 기타 자산을 Helix로 브릿지하세요.',
        gasRequirement: '거래 수수료를 위해 최소 0.1 INJ를 확보하세요.',
        step1: {
          title: '1단계',
          description: 'Injective 브릿지에 방문 후 지갑을 연결하세요.'
        },
        step2: {
          title: '2단계',
          description:
            '소스 체인을 선택하세요 (예: 이더리움(Ethereum), 코스모스(Cosmos) 혹은 솔라나(Solana)).'
        },
        step3: {
          title: '3단계',
          description: 'USDT 또는 다른 자산을 선택하세요.'
        },
        step4: {
          title: '4단계',
          description:
            '전송이 완료되면 Helix로 돌아와 포트폴리오 페이지에서 잔액을 확인하세요. 이제 거래할 준비가 완료되었습니다!'
        }
      },
      mobile: {
        usp1: '초보자도 쉽게 사용',
        title: '모바일로 간편하게 선물 거래',
        usp2: '암호화폐, 주식, 원자재 및 외환',
        downloadHelixMobile: 'Helix 모바일 다운로드'
      },
      faq: {
        title: '자주 묻는 질문',
        or: '또는',
        on: '에서',
        and: '및',
        here: '여기',
        fullstop: '.',
        accordion1: {
          title: 'Helix에서는 어떤 기능을 사용할 수 있나요?',
          featureTitle:
            'Helix는 고급 성능과 유연성으로 원활하고 강력한 거래 경험을 제공합니다:',
          stocks: '주식',
          lpRewards: 'LP 리워드',
          commodities: '원자재',
          spotMarkets: '현물 마켓',
          tradingBots: '트레이딩 봇',
          autoSigning: '자동 서명',
          makerRebates: 'Maker 리베이트',
          feeDiscounts: '수수료 할인',
          oneHundredLeverage: '100배 레버리지',
          perpetualMarkets: '무기한 마켓',
          tradingCompetitions: '트레이딩 대회',
          feature1: '{spotMarkets}에서 주요 암호화폐 페어를 거래하세요.',
          feature2:
            '암호화폐, {stocks}, 금, 은과 같은 {commodities}를 포함한 {perpetualMarkets}에서 최대 {oneHundredLeverage}를 사용하세요.',
          feature3:
            '현물 및 무기한 마켓을 위한 내장된 {tradingBots}으로 전략을 자동화하세요.',
          feature4:
            'INJ를 스테이킹하여 {lpRewards}, {makerRebates}, {feeDiscounts}를 통해 수익을 얻으세요.',
          feature5:
            '{autoSigning}과 가스비 없는 경험으로 원활한 거래를 즐기세요.',
          feature6:
            '다양한 {tradingCompetitions}에 참여하고 특별한 보상을 잠금 해제하세요.'
        },
        accordion2: {
          title: 'Helix에 자산을 어떻게 가져오나요?',
          optionTitle:
            'Helix에서 거래를 시작하려면 먼저 Injective에서 USDT나 INJ 같은 자산을 확보해야 합니다:',
          fiatOnRamps: '법정화폐 On-ramp',
          injectiveBridge: 'Injective 브릿지',
          option1:
            '{fiatOnRamps}를 통해 암호화폐를 구매하세요 (체크/신용카드, Revolut, Apple Pay, Google Pay 등).',
          option2:
            '{injectiveBridge}를 사용하여 다른 체인에서 자산을 입금하세요.',
          option3:
            '또는 Binance, ByBit 등 다른 중앙화 거래소에서도 입금할 수 있습니다.'
        },
        accordion3: {
          title: 'Helix에서 암호화폐를 거래하려면 어떻게 해야하나요?',
          stepTitle:
            'Helix에서의 거래는 빠르고, 허가가 필요 없으며, 가스비가 전혀 없습니다. 시작하는 방법은 다음과 같습니다:',
          inj: 'INJ',
          spot: '현물',
          usdt: 'USDT',
          limit: '지정가',
          helix: 'helixapp.com',
          perpetual: '무기한',
          marketOrder: '시장가 주문',
          videoTutorialHere: '영상 튜토리얼 보기',
          step1: '{helix}로 이동하여 지갑을 연결하세요.',
          step2: '{usdt}나 {inj} 같은 자산을 입금하거나 브릿지를 이용하세요.',
          step3: '거래하고 싶은 {spot} 또는 {perpetual} 마켓을 선택하세요.',
          step4: '몇 번의 클릭만으로 {limit} 또는 {marketOrder}를 제출하세요.',
          cta: '자세한 설명이 필요하신가요? 저희의 단계별 {tutorial}을 확인해보세요.'
        },
        accordion4: {
          title: 'Helix 모바일 앱이 있나요? 어디에서 다운로드할 수 있나요?',
          appStore: 'IOS (App Store)',
          playStore: 'Android (Google Play)',
          description:
            'Helix 모바일은 {appStore} 및 {playStore}에서 무료로 제공됩니다. 앱을 설치하고 지갑을 연결하면 웹에서 보던 것과 동일한 시장 및 잔액을 확인할 수 있습니다.'
        },
        accordion5: {
          title: 'Helix 모바일에서 지갑을 어떻게 연결하나요?',
          description: '세 가지 옵션이 있습니다:',
          option1:
            "QR 코드 스캔 - Helix 모바일을 열고 'Helix 웹에서 QR 코드 스캔'을 탭한 다음, 설정의 Helix 웹 앱에 표시된 QR 코드에 카메라를 맞추세요. (ACM의 AuthZ 모듈 링크)",
          option2:
            '기존 소셜 로그인 사용 - 데스크톱에서 사용하는 것과 동일한 Google 또는 Apple 계정으로 로그인하면 지갑이 즉시 나타납니다.',
          option3:
            '새 지갑 만들기 - 처음부터 시작하고 싶다면 이메일에 연결된 새로운 비수탁형 지갑을 생성하세요.'
        },
        accordion6: {
          title: 'Helix 모바일은 내 자산을 어떻게 안전하게 보호하나요?',
          description:
            'Helix 모바일 앱은 완전한 비수탁형입니다. 개인 키는 사용자의 기기에 저장되고, 트랜잭션은 로컬에서 서명되며, 설정에서 생체 인식 2단계 인증을 추가할 수 있습니다. Helix는 절대로 사용자의 자금이나 시드 구문을 보관하지 않으며, 보안은 웹에서와 동일하게 작동합니다. 소셜 로그인의 경우, 키는 업계 표준 키 관리 솔루션인 Turnkey에 의해 안전하게 저장됩니다.'
        }
      }
    },
    swap: {
      fees: '수수료',
      rate: '비율',
      title: '스왑',
      route: '루트',
      youPay: '지불 금액',
      youReceive: '수령 금액',
      backToSwap: '스왑으로 돌아가기',
      enterAmount: '금액 입력',
      maximumInput: '최대 입력값',
      tolerance: '슬리피지 허용 범위',
      minimumOutput: '최소 수령 금액',
      connectWallet: '지갑 연결',
      expectedOutput: '예상 수령 금액',
      viewTransaction: '트랜잭션 보기',
      advancedSettings: '고급 설정',
      currentlyOffline: '현재 오프라인 상태입니다.',
      swapTime: '스왑 중 ({swapTimeRemaining}초)',
      somethingWentWrong: '문제가 발생했습니다.',
      swappedSuccessfully: '스왑이 완료되었습니다!',
      rateExpired: '비율 갱신이 필요합니다. 클릭하여 업데이트하세요',
      swapAmountTooLow: '스왑 금액이 너무 적습니다.',
      insufficientLiquidity: '유동성이 부족합니다.',
      pleaseTryAgain: '페이지를 새로고침하고 다시 시도해주세요.',
      tooltip:
        '가격이 설정한 슬리피지 이상으로 불리하게 변동되면 거래가 자동으로 취소됩니다.',
      youHaveSwapped:
        '{inputAmount} {inputTokenSymbol} → {outputAmount} {outputTokenSymbol} 로 스왑되었습니다.',
      priceWarning:
        '높은 슬리피지가 감지되었습니다! 예상보다 적은 {symbol}을 받을 수 있으니 주의하세요.'
    },
    guild: {
      title: '길드',
      description:
        'Helix 길드는 팀 단위의 트레이딩 대회입니다. 길드의 일원이 되어 함께 승리하세요!',
      rewardDescription1:
        '각 길드에는 두 가지 순위가 있습니다. 하나는 TIA/USDT 마켓에서 길드 전체가 기록한 누적 거래량 기준, 다른 하나는 모든 길드원의 TIA 보유량 가중 평균 기준입니다. 각 항목의 1위 길드는 500 INJ와 5,000 TIA를 받을 수 있습니다.',
      rewardDescription2:
        '각 길드는 최대 150명까지만 참여할 수 있으니 지금 바로 가입하세요!',
      inactiveDescription:
        '길드 마스터의 TIA 보유량이 {amount} TIA 이상일 때부터 길드의 거래량이 반영됩니다.',
      inactiveTooltip: '길드 마스터의 TIA 보유량이 {amount} TIA 미만입니다.',
      you: '당신',
      guilds: '길드',
      noData: '데이터 없음',
      endsIn: '종료까지 남은 시간',
      rewards: '보상',
      readyIn: '준비 시간',
      startsIn: '시작까지 남은 시간',
      seasonEnded: '시즌 종료',
      startOn: '{date} 시작',
      participants: '참가자 수',
      totalRewards: '총 보상',
      showInactive: '비활성 길드 보기',
      currentSeason: '현재 시즌',
      campaignRules: '캠페인 규칙',
      seasonOneEnded: '시즌 1 종료',
      howToParticipate: {
        title: '참여 방법',
        createGuild: {
          cta: '길드 만들기',
          title: '길드 마스터가 되어 팀원을 초대하세요',
          description:
            '대회 기간 동안 지갑에 최소 {amount} TIA를 유지하세요. 길드가 우승하면 보상의 20%를 획득합니다!'
        },
        joinGuild: {
          cta: 'Injective 디스코드 방문',
          title: '길드에 가입하고 친구들과 함께 승리하세요',
          description:
            '더 많은 TIA를 보유하고 활발한 거래로 순위 상승! 길드가 우승하면 보상의 80%를 동료와 나눌 수 있어요.',
          description2:
            '#helix-guilds Discord 채널에서 길드를 찾거나 친구에게 초대 코드를 요청해보세요'
        }
      },
      leaderboard: {
        title: '리더보드',
        guildMembers: '길드 멤버',
        fetchNewData: '데이터 새로고침',
        invitationCode: '초대 코드',
        lastUpdated: '마지막 업데이트: {date}',
        guildMasterAddress: '길드 마스터 주소',
        guildMasterBalance: '현재 길드 마스터 TIA 보유량',
        tab: {
          rankByVolume: '거래량 순위',
          rankByTVL: 'TIA 보유량 순위'
        },
        table: {
          rank: '순위',
          guild: '길드',
          status: '상태',
          balance: '보유량',
          members: '구성원',
          address: '주소',
          volumeRank: '거래량 순위',
          tvlRank: 'TIA 보유량 순위',
          tradingVolume: '거래량',
          totalTIABalance: '총 TIA 보유량',
          totalTradingVolume: '총 거래량',
          weightedAverageTiaBalance: 'TIA 보유량에 따른 가중평균',
          tiaBalanceTooltip:
            '대회 기간 동안 해당 주소에 보유된 TIA의 가중 평균',
          volumeTooltip:
            '대회 기간 동안 해당 주소에서 발생한 테이커 및 메이커 거래량'
        }
      },
      createGuild: {
        cta: '길드 만들기',
        title: '길드 만들기',
        characters: '캐릭터',
        name: '길드 이름',
        namePlaceholder: '이름 입력',
        description: '길드 설명',
        thumbnail: '길드 썸네일 선택',
        masterAddress: '길드 마스터 주소',
        findAGuildToJoin: '가입할 길드 찾기',
        insufficientBalance: '잔액 부족',
        balanceInWallet: '지갑의 {symbol} 잔액:',
        insufficientBalanceDescription:
          '길드 마스터는 생성 시점을 포함하여 전체 대회 기간 동안 지갑에 최소 {amount} {symbol}을 보유해야 합니다.'
      },
      joinGuild: {
        cta: '길드 가입',
        maxCap: '최대 인원',
        title: '길드에 가입하기',
        invitationCode: 'Discord에서 초대 코드 받기',
        description:
          'Helix에서 "{name}" 길드에 가입하여 보상을 나누어 받으세요!'
      },
      verifyJoinGuild: {
        cta: '가입',
        hash: '초대 코드',
        title: '초대 코드 입력',
        incorrectCode: '잘못된 코드',
        hashPlaceholder: '초대 코드 입력',
        description: '이 길드에 가입하려면 초대 코드를 제공해주세요.'
      },
      alreadyPartOfGuild: {
        title: '이미 길드 멤버입니다',
        description:
          '{address}는 이미 길드에 속해 있습니다. 각 주소는 대회 기간 동안 하나의 길드에만 속할 수 있습니다.'
      }
    },
    toast: {
      error: '오류',
      success: '성공',
      addressCopied: '주소 복사됨',
      viewOnInjScan: 'InjScan에서 보기',
      contextCopied: '내용 복사됨!',
      marketIdCopied: '마켓 ID 복사됨',
      somethingHappened: '문제가 발생했습니다...',
      connectedSuccessfully: '성공적으로 연결됨 ',
      copiedAddressToClipboard: '주소가 클립보드에 복사됨',
      formSubmittedSuccessfully: '양식이 성공적으로 제출됨.',
      transactionFinalized:
        '트랜잭션이 {duration}초 만에 완료됨. {viewOnInjScan}',
      onramperSuccess:
        '성공! {fiatCurrency}로 {cryptoAmount} {crypto}를 구매했습니다. 토큰이 전송 중입니다.',
      account: {
        authZAdded: 'AuthZ 계정 추가됨',
        assetsTransferred: '자산이 귀하의 계정으로 전송됨',
        transferToSubaccountSuccess: '서브계정 전송 성공'
      },
      authz: {
        connectedAs: '다음으로 연결됨'
      },
      portfolio: {
        buyInj: 'INJ 구매',
        bridgeNow: '지금 브릿지',
        bankTransferSuccessful: '전송 성공',
        startTradingInSeconds: '단 몇 초면 트레이딩 시작!',
        readyToTrade: '트레이딩 준비 완료? 지금 마켓 탐색하기!',
        moveAssetsToInj: 'Ethereum에서 Injective로 자산 이동',
        discoverTrendingPairs: '인기 페어를 발견하고 트레이딩 시작',
        moveAssetsToInjTitle: '암호화폐를 Injective로 이동하여 트레이딩 시작',
        topUpWithCreditOrDebit:
          '신용카드나 직불카드로 충전하고 오늘부터 트레이딩하세요.',
        autoSign: {
          disabledToast: '자동 서명 비활성화됨',
          enabledToast: {
            title: '자동 서명 활성화됨',
            description: '자동 서명이 3일간 활성화되었습니다.'
          },
          enable: {
            title: '자동 서명',
            description:
              '활성화하면 각 트랜잭션에 서명하지 않고도 Helix에서 더 원활하게 거래할 수 있습니다.'
          }
        }
      },
      trade: {
        invalidPrice: '유효하지 않은 가격',
        orderCancelled: '주문 취소됨',
        positionClosed: '포지션 종료됨',
        noLiquidity: '유동성 부족',
        orderPlaced: '주문이 성공적으로 배치됨',
        tpSuccessMessage: 'TP가 {price}로 설정됨',
        slSuccessMessage: 'SL이 {price}로 설정됨',
        allOrdersCancelled: '모든 주문 취소됨',
        orderUpdated: '주문이 성공적으로 업데이트됨',
        slOrderCancelled: '손절매 주문 취소됨',
        successAddedMargin: '마진이 성공적으로 추가됨',
        tpOrderCancelled: '익절매 주문 취소됨',
        advancedOrderCancelled: '고급 주문 취소됨',
        allAdvancedOrdersCancelled: '모든 고급 주문 취소됨',
        rwaMarketClosedToast:
          '이 마켓은 현재 폐장되었습니다. 거래를 진행할 수 있지만 관련 위험을 주의하세요.',
        neptuneUsdt: {
          success: {
            deposit: 'Neptune 입금 성공',
            withdraw: 'Neptune 출금 성공'
          }
        },
        tradeToast: {
          sold: '{quantity} {symbol}를 평균 가격 ${usdPrice}에 매도',
          bought: '{quantity} {symbol}를 평균 가격 ${usdPrice}에 매수'
        }
      },
      referral: {
        referralLinkCopied: '추천 링크 복사됨',
        referralLinkIsUnavailable: '추천 링크를 사용할 수 없음',
        success: '코드가 성공적으로 적용되었습니다. 지금 마켓을 탐색해보세요!',
        referralLinkExists: '이 지갑에 이미 다른 추천 코드가 적용되어 있습니다',
        joinSelfReferralMessage:
          '추천 코드는 유효하지만 자신을 추천할 수 없습니다. 다른 사람에게 공유해주세요!'
      },
      leaderboard: {
        receivedInformation: '정보가 입력되었습니다. 팀에서 곧 연락드리겠습니다'
      },
      campaign: {
        errorAlreadyClaimed: '이미 보상을 받았습니다',
        notFound: '캠페인을 찾을 수 없습니다. 나중에 다시 시도해주세요',
        successfullyClaimedRewards: '보상이 성공적으로 받아졌습니다.'
      },
      guild: {
        successfullyJoinGuild: '길드 가입 성공',
        successfullyCreateGuild: '길드 생성 성공',
        copiedInvitationLink: '초대 코드가 클립보드에 복사되었습니다.'
      },
      tradingBots: {
        tradingBotRemovedSuccessfully: '트레이딩 봇이 성공적으로 제거됨',
        tradingBotCreatedSuccessfully: '트레이딩 봇이 성공적으로 생성됨'
      },
      stockTwits: {
        startHere: '여기서 시작',
        title: '👋 Helix가 처음이신가요?',
        description: '쉽게 암호화폐와 토큰화된 주식 거래를 시작해보세요.'
      }
    },
    trade: {
      tp: 'TP',
      sl: 'SL',
      fee: '수수료',
      buy: '매수',
      max: '최대',
      size: '크기',
      info: '정보',
      long: '롱',
      sell: '매도',
      spot: '현물',
      time: '시간',
      open: '열림',
      sold: '매도됨',
      tpSl: 'TP/SL',
      chase: '추격',
      price: '가격',
      total: '총액',
      limit: '지정가',
      short: '숏',
      chart: '차트',
      depth: '호가',
      trade: '거래',
      amount: '수량',
      filled: '체결됨',
      market: '시장가',
      trades: '거래내역',
      margin: '마진',
      volume: '거래량',
      bought: '매수됨',
      markets: '마켓',
      details: '세부사항',
      quantity: '수량',
      leverage: '레버리지',
      standard: '표준',
      addTpSl: 'TP/SL 추가',
      tickSize: '틱 사이즈',
      stopLoss: '손절매',
      postOnly: 'Post Only',
      noTrades: '거래내역 없음',
      noOrders: '주문 없음',
      notAvailableNA: '해당없음',
      avgPrice: '평균 가격',
      direction: '방향',
      orderbook: '오더북',
      editTpSl: 'TP/SL 편집',
      triggered: '트리거됨',
      cancelled: '취소됨',
      markPrice: '마크 가격',
      cancelAll: '전체 취소',
      addMargin: '마진 추가',
      viewOrder: '주문 보기',
      orderType: '주문 종류',
      'pro-chart': 'Pro 차트',
      placeOrder: '주문 실행',
      allMarkets: '전체 마켓',
      marketName: '마켓명',
      takeProfit: '익절매',
      limitPrice: '지정가격',
      worstPrice: '최악 가격',
      entryPrice: '진입 가격',
      reduceOnly: '포지션 감소만',
      profitLoss: '손익',
      balanceTitle: '사용 가능',
      openOrders: '미체결 주문',
      reduce_only: '포지션 감소만',
      'stop-limit': '스탑-지정가',
      derivatives: '파생상품',
      liquidation: '청산',
      slippage: '슬리피지',
      advanced: '고급 설정',
      tickerOnly: '{ticker} 전용',
      cancelOrder: '주문 취소',
      showOrders: '주문 표시',
      makerRate: '메이커 수수료율',
      maxLeverage: '최대 레버리지',
      'stop-market': '스탑-시장가',
      confirmTpSl: 'TP/SL 확인',
      triggerPrice: '트리거 가격',
      averagePrice: '평균 가격',
      'trading-bots': '트레이딩 봇',
      emptyOrders: '주문이 없습니다',
      emptyTrades: '거래내역이 없습니다',
      totalNotional: '총 명목가치',
      closePosition: '포지션 종료',
      estFeeRebate: '예상 수수료 리베이트',
      partialFilled: '부분 체결',
      proceedAnyway: '계속 진행',
      maxSlippage: '최대: {max}%',
      stopLossLimit: '손절매 지정가',
      searchMarket: '마켓 검색...',
      boostedMarkets: '마켓 보상',
      priceDeviation: '가격 편차',
      pnlPercent: 'PnL% (미결 포지션)',
      stopLossMarket: '손절매 시장가',
      cancelStopLoss: '손절매 취소',
      availableMargin: '사용 가능 마진',
      partiallyFilled: '부분 체결됨',
      cancelAllOrders: '모든 주문 취소',
      takeProfitLimit: '익절매 지정가',
      enterYourAmount: '수량을 입력하세요',
      advancedSettings: '고급 설정',
      totalVolume: '총 거래량 ({symbol})',
      stopLossQuantity: '손절매 수량',
      takeProfitMarket: '익절매 시장가',
      cancelTakeProfit: '익절매 취소',
      availableAmount: '사용 가능: {amount}',
      makerTakerRate: '메이커/테이커 수수료율',
      sharePnl: '손익 공유',
      noOrderHistory: '주문 내역 없음',
      noTradeHistory: '거래 내역 없음',
      noOpenPositions: '진행 중인 포지션 없음',
      slippageTolerance: '슬리피지 허용 범위',
      previousMarkPrice: '이전 마크 가격',
      totalQuantitySize: '총 수량 크기',
      marketsInformation: '마켓 정보',
      minLimitOrderSize: '최소 지정가 주문 크기',
      bypassPriceWarning: '가격 경고 우회',
      totalQuantity: '총 수량 ({symbol})',
      takeProfitQuantity: '익절매 수량',
      disqualifiedMarkets: '자격 박탈 마켓',
      estLiquidationPrice: '예상 청산 가격',
      stopLossTriggerPrice: '손절매 트리거 가격',
      emptyAdvancedOrders: '조건부 주문이 없습니다',
      takeProfitTriggerPrice: '익절매 트리거 가격',
      modifyTakeProfitStopLoss: '익절매 / 손절매 수정',
      postOnlyWarning: '체인 업그레이드로 인해 일시적으로 Post-Only 모드',
      minNotionalError: '최소 주문 가치 > {minNotional} {symbol}',
      doNotShowThisConfirmationAgain: '이 확인창을 다시 표시하지 않음',
      availableMarginTooltip: '이 포지션에 추가할 수 있는 사용 가능한 마진',
      thereAreNoDisqualifiedMarketsOnThisRelayer:
        '이 릴레이어에는 자격이 박탈된 마켓이 없습니다.',
      tensMultiplierRounded: '{minTickSize}의 가장 가까운 배수로 자동 반올림됨',
      markPriceInvalid:
        '마크 가격 요구사항을 충족하려면 가격, 수량 또는 레버리지를 수정해주세요',
      eip712Warning:
        '사용량이 매우 많아 현재 가스비 없는 거래를 이용할 수 없습니다',
      slippageTooltip:
        '슬리피지 허용 범위는 거래가 취소되기 전에 허용되는 최대 가격 변동입니다.',
      makerTakerRateTooltip:
        '메이커 주문은 {makerFeeRate}%의 수수료가 부과됩니다. 테이커 주문은 {takerFeeRate}%의 수수료가 부과됩니다.',
      stopLossDetails:
        '마크 가격이 {price}에 도달하면 {quantity}에 대한 손절매 시장가 주문이 트리거됩니다.',
      takeProfitDetails:
        '마크 가격이 {price}에 도달하면 {quantity}에 대한 익절매 시장가 주문이 트리거됩니다.',
      slippageWarning:
        '슬리피지 %가 너무 높게 설정되면 거래가 불리한 가격에 실행될 수 있습니다.',
      positionUsedTooltip:
        '{quantity}이 다른 주문에 사용되고 있습니다. 미체결 주문을 취소하거나 수정할 수 있습니다.',
      disqualifiedMarketsTooltip:
        'Trade & Earn에서 자격이 박탈된 마켓입니다. 이러한 마켓에서의 거래 활동은 보상 포인트를 얻을 수 없습니다.',
      worstPriceTooltip:
        '최악 가격은 슬리피지 허용 범위에 따라 매수 시 지불할 최고 가격 또는 매도 시 받을 최저 가격을 반영합니다.',
      chaseTooltip:
        '추격을 클릭하여 이 미체결 지정가 주문을 현재 최적 매수/매도 가격으로 자동 수정하세요. 이 기능을 사용하려면 자동 서명이 활성화되어 있어야 합니다.',
      boostedMarketsTooltip:
        '각 마켓에서 테이커 및 메이커 주문에 대한 보상 비율입니다. 예: 3x 메이커 포인트는 이 마켓에서 메이커 주문이 지불한 거래 수수료가 거래 수수료 가치의 3배에 해당하는 보상 포인트를 받는다는 의미입니다.',
      slippageModal: {
        title: '최대 슬리피지 조정',
        description:
          '허용 가능한 최대 슬리피지를 설정하세요. 가격이 이 비율보다 더 변동하면 주문이 실행되지 않습니다.'
      },
      tab: {
        orders: '주문',
        balances: '잔액',
        positions: '포지션',
        openOrders: '미체결 주문',
        orderHistory: '주문 내역',
        tradeHistory: '거래 내역',
        advancedOrders: '조건부 주문',
        fundingHistory: '펀딩 내역',
        activeStrategies: '활성 전략',
        removedStrategies: '제거된 전략'
      },
      rwa: {
        closed: '폐장',
        nyseClosedTimes: 'NYSE 거래 시간',
        statusOfThisMarket: '이 마켓의 상태',
        rwaClosedTimes: ' 전통적인 RWA 가격 피드',
        nyseClosedMarketRow: '이 마켓은 NYSE 거래 시간을 따릅니다.',
        thisMayIncreaseYourTradingRisk:
          '이는 거래 위험을 증가시킬 수 있습니다.',
        rwaClosedMarketRow: '이 마켓은 전통적인 RWA 가격 피드를 따릅니다.',
        acknowledge: '이해했으며, 위험을 감수하고 거래를 진행하겠습니다.',
        tradesCanBePlace:
          '이 시간 외에도 거래를 진행할 수 있지만, 마켓이 재개될 때까지 가격이 업데이트되지 않습니다.',
        nyseMarketClosedTrade:
          'Helix의 모든 마켓은 24/7 거래가 가능합니다. 이 마켓은 {nyseClosedTimes}, UTC 14:30부터 21:00까지를 따르며, 야간, 주말, NYSE 거래 휴일에는 폐장됩니다.',
        marketClosedTrade:
          'Helix의 모든 마켓은 24/7 거래가 가능합니다. 이 마켓은 {marketClosedTimes}를 따릅니다. 마켓은 금요일 17시(ET)부터 일요일 17시(ET)까지, CME 거래 휴일, 그리고 월요일부터 목요일까지 17시(ET)부터 18시(ET)까지 폐장됩니다.'
      },
      stats: {
        low: '24시간 최저가',
        high: '24시간 최고가',
        usdValue: 'USD 가치',
        marketCap: '시가총액',
        annualized: '연율화',
        nextFunding: '다음 펀딩',
        volumeInUsd: '거래량 USD (24시간)',
        marketVolume24h: '거래량 (24시간)',
        fundingOrCountdown: '펀딩 / 카운트다운',

        marketCapTooltip:
          '시가총액은 현재 가격에 현재 유통 공급량을 곱하여 계산됩니다. Injective의 일부 토큰은 최대 공급량이 무한대입니다.',
        fundingRateTooltip:
          '펀딩 지불은 무기한 가격과 현물 가격 간의 차이를 기반으로 합니다. 비율이 양수이면 롱이 숏에게 지불하고, 음수이면 숏이 롱에게 지불합니다.',
        markPriceTooltip:
          '마진 계산, 미실현 PNL 및 펀딩 비율 계산, 청산, TP/SL 주문에 사용됩니다.'
      },
      marketMultiplierBanner: {
        description:
          "이 마켓은 {startDate}부터 {duration}시간 동안 'Like a G' 대회 참가자에게 {multiplier}배 승수를 제공합니다. 승수는 나중에 리더보드에 반영됩니다. {terms}이 적용됩니다."
      },
      equity: {
        spot: '현물',
        perps: '무기한',
        title: '계정 자산',
        unrealizedPnl: '미실현 손익'
      },
      neptuneUsdt: {
        apy: 'APY',
        submit: '제출',
        deposit: '입금',
        neptune: 'Neptune',
        withdraw: '출금',
        available: '사용 가능',
        deposited: '예치됨',
        availableUSDT: '사용 가능한 USDT',
        depositToNeptune: 'Neptune에 입금',
        percentageInReserve: '(15% 예비금)',
        automatedYields: 'Helix 자동화 수익률',
        withdrawFromNeptune: 'Neptune에서 출금',
        availableUsdt: '≈{peggyUsdt} USDT + {neptuneUsdt} Neptune USDT',
        apyTooltip:
          '이는 Neptune이 현재 USDT 예금에 대해 제공하는 APY입니다. 이 금액은 시간이 지남에 따라 변경됩니다.',
        banner:
          'Helix는 Neptune과 파트너십을 맺어 애플리케이션을 떠나지 않고도 스테이블코인으로 수익을 얻을 수 있도록 했습니다. {here}를 클릭하여 시작하세요!',
        description:
          '{link}의 USDT 대출 풀에 스테이블코인을 예치하여 Helix를 떠나지 않고도 자동으로 수익을 얻으세요. 거래할 준비가 되면 추가 단계 없이 대출 풀에서 자금이 자동으로 인출됩니다.',
        warningText:
          '계속 진행하면 Injective가 통제하거나 제휴하지 않은 애플리케이션에 자금을 예치하게 됩니다. 이 애플리케이션의 사용은 전적으로 귀하의 책임이며, 그로 인해 발생할 수 있는 손실에 대해 Injective를 면책하는 데 동의합니다. 자세한 내용은 Helix {terms}를 참조하세요.'
      },
      stocksModal: {
        cta: '트레이딩 시작',
        description:
          '세계 최고의 탈중앙화 거래소에서만 25배 레버리지로 온체인 주식 선물을 거래하는 최초의 사용자가 되어보세요.'
      },
      marketRestricted: {
        tradeSpot: '현물 거래',
        cta: '홈페이지로 돌아가기',
        swapCta: '{symbol}은 귀하의 지역에서 이용할 수 없습니다.',
        title: {
          spot: '{symbol} 제한됨',
          perpetual: '무기한 거래 제한됨'
        },
        description: {
          spot: '규제 제한으로 인해 {symbol}은 귀하의 지역에서 이용할 수 없습니다.',
          perpetual:
            '규제 제한으로 인해 무기한 계약은 귀하의 지역에서 이용할 수 없습니다. 하지만 현물 마켓에서는 여전히 거래할 수 있습니다.'
        }
      },
      marketNotOnHelix: {
        cta: '이해했습니다',
        title: '실험적 마켓',
        termsAndCondition: '이용약관',
        description:
          'Injective에서 이용 가능하지만 Helix에 등재되지 않은 마켓에 액세스하고 있습니다. 마켓 ID가 거래하려는 것인지 확인해주세요.',
        description2:
          '계속 진행함으로써 Helix {0}을 읽었고, 동의하며, Helix 사용에 대해 구속받는다는 것을 인정합니다'
      },
      sharePnlModal: {
        markPrice: '시장 평균가',
        exitPrice: '출구 가격',
        entryPrice: '진입 가격',
        mobileDownloadNote: '다운로드는 데스크톱에서 가능합니다'
      },
      leverageModal: {
        title: '레버리지 설정',
        upTo: '최대 {leverageAmount}배',
        leverageAt: '현재 레버리지: {leverageAmount}배',
        description:
          '레버리지가 높을수록 수익률이 커질 수 있으나, 손실 및 청산 위험도 증가합니다.'
      },
      partialClosePositionModal: {
        limitClose: '지정가 종료',
        marketClose: '시장가 종료',
        marketTitle: '부분 포지션 종료',
        totalPositionSize: '총 포지션 크기'
      },
      table: {
        markets: {
          markets: '마켓',
          'last-price': '최종 가격',
          'market-change-24h': '변동 (24시간)',
          'market-volume-24h': '거래량 (24시간)'
        },
        marketsSelector: {
          markets: '마켓',
          'last-price': '최종 가격',
          'market-volume-24h': '거래량 (24시간)',
          'market-change-24h': '변동 (24시간)',
          'funding-rate': '예상 펀딩 (1시간)'
        }
      }
    },
    vault: {
      TVL: 'TVL',
      APY: 'APY',
      title: 'Mito Vault로 수익 극대화',
      description:
        'Mito의 자동화된 마켓 메이킹 볼트로 암호화폐 보유량을 극대화하세요. Injective 생태계의 주요 프로젝트에 유동성을 제공하여 오늘부터 패시브 인컴을 얻기 시작하세요.',
      item: {
        'mito-vault': 'LP Vault',
        'injective-staking': '스테이킹',
        'helix-spot-grid-bot': '현물 Grid 트레이딩 봇'
      },
      modal: {
        continueToMito: 'Mito로 계속',
        redirect:
          '볼트 진입 시 Helix에서 수익을 얻을 수 있는 Mito로 리디렉션됩니다.'
      }
    },
    markets: {
      vol: 'Vol',
      marketId: '마켓 ID',
      showLowVol: '낮은 거래량 표시',
      newMarkets: '🐤 신규 마켓',
      topGainers: '🚀 상승률 상위',
      closePositionWarningTitle: '높은 가격 임팩트 감지됨',
      docsTooltip:
        '이 상품은 Index Perp입니다. 자세한 정보는 {docs}를 참조하세요.',
      expiryDocsTooltip:
        '이 상품은 만기 선물 계약입니다. 자세한 내용은 {docs}를 참조하세요.',
      indexMarketTooltip:
        '이 마켓은 {label}을 따릅니다. 자세한 내용은 {link}에서 확인할 수 있습니다.',
      closePositionWarningDescription:
        '시장가 주문으로 이 미결 포지션을 종료하면 불리한 실행 가격이 발생할 수 있습니다. 대신 지정가 주문으로 종료하는 것을 고려해보세요.',
      '2024ElectionTooltip':
        '이 마켓은 Polymarket 2024 대통령 선거 마켓 가격 피드를 따르며, TRUMPWIN을 기초 자산으로 합니다. 자세한 내용은 {docs}를 방문하세요.',
      filters: {
        all: '전체',
        favorites: '즐겨찾기',
        perps: '무기한',
        spot: '현물',
        trending: '인기',
        injective: 'Injective',
        'layer-1': 'L1',
        deFi: 'DeFi',
        ai: 'AI',
        rwa: 'RWA'
      }
    },
    connect: {
      beta: '베타',
      wallet: '지갑',
      trezor: 'Trezor',
      address: '주소',
      ledgerLive: 'Ledger Live',
      trezorBip44: 'Trezor Bip44',
      getAddresses: '주소 가져오기',
      ledgerLegacy: 'Ledger Legacy',
      walletAddress: '지갑 주소',
      connectWallet: '지갑 연결',
      derivationPath: 'Derivation Path',
      showMoreWallets: '더 많은 지갑 보기',
      showLessWallets: '더 적은 지갑 보기',
      injectiveAddress: 'Injective 주소',
      getMoreAddresses: '더 많은 주소 가져오기',
      selectDerivationPath: 'Derivation Path 선택',
      connectUsingBrowser: '브라우저 지갑을 사용하여 연결',
      selectAddressToConnect: '연결할 주소 선택',
      connectUsingHardware: '하드웨어 지갑을 사용하여 연결',
      connectDeprecatedSSO: '지원 중단된 로그인을 사용하여 연결',
      qrTitle: '이 주소로는 INJ 네트워크 자산만 입금하세요',
      otpDescription: '이메일 확인을 위해 일회용 코드를 입력하세요',
      getAddressNote: '주소를 가져오는 중입니다. 잠시만 기다려주세요...',
      pleaseConnectToYourWallet: '자세한 내용을 보려면 지갑을 연결해주세요',
      pleaseConnectToYourWalletCta:
        'Injective에서 트레이딩을 시작하려면 지갑을 연결해주세요!',
      connectUsingTrezorNote:
        '참고: Trezor 하드웨어 지갑 연결 과정을 원활하게 진행하려면 최신 Chrome 버전을 실행하고 있는지 확인하고, Trezor 장치가 연결되고 잠금 해제되어 있는지 확인하세요.',
      connectUsingLedgerNote:
        '참고: Ledger 하드웨어 지갑 연결 과정을 원활하게 진행하려면 최신 Chrome 버전을 실행하고 있는지 확인하고, Ledger 장치가 연결되고 잠금 해제되어 있으며 Ethereum 앱이 열려 있는지 확인하세요.',
      sso: {
        google: {
          cta: 'Google로 로그인'
        },
        email: {
          cta: '계속',
          placeholder: '이메일 주소'
        }
      },
      deprecate: {
        cta: '지갑 마이그레이션',
        title: '필수 조치: 지갑 마이그레이션',
        description:
          '지갑 제공업체를 업그레이드하고 있으며 현재 사용 중인 것은 지원이 중단됩니다. 다음을 따라 지갑을 마이그레이션할 것을 강력히 권장합니다',
        migrateDescription:
          '더 빠르고 간단하며 안전한 로그인 방식으로 업그레이드했습니다. Helix를 계속 사용하려면 업데이트된 지갑을 연결하여 자산을 이동해주세요. 잠시만 시간이 걸리며, 자금은 항상 안전합니다.'
      },
      option: {
        leap: 'Leap',
        keplr: 'Keplr',
        ninji: 'Ninji',
        rabby: 'Rabby',
        ledger: 'Ledger',
        phantom: 'Phantom',
        rainbow: 'Rainbow',
        metamask: 'Metamask',
        'trezor-bip32': 'Trezor',
        'trezor-bip44': 'Trezor Bip44',
        'okx-wallet': 'OKX Wallet',
        BitGet: 'Bitget Wallet',
        magic: '"레거시 로그인"',
        'trust-wallet': 'Trust Wallet',
        cosmostation: 'Cosmostation',
        'wallet-connect': 'Wallet Connect'
      }
    },
    points: {
      rank: '순위',
      level: '레벨',
      share: '공유',
      title: '포인트',
      period: '기간',
      points: '포인트',
      volume: '거래량',
      paginationDetails: '{from}-{to} / 총 {total}',
      leagues: {
        blue: '블루 벨트',
        black: '블랙 벨트',
        white: '화이트 벨트',
        orange: '오렌지 벨트',
        purple: '퍼플 벨트'
      }
    },
    banners: {
      findOutMore: '자세히 알아보기',
      stockTwits:
        '거래 방법이나 토큰화된 주식 거래 작동 방식을 알고 싶으신가요? → {learnMore}',
      deprecatedWallet:
        '이 지갑은 지원이 중단되었습니다. 마이그레이션 가이드를 따라 자금을 이동하세요. {learnMore}',
      deprecatedWalletWithAddress:
        '이 지갑은 지원이 중단되었습니다. 새로운 SSO 주소는 {address}입니다. 마이그레이션 가이드를 따라 자금을 이동하세요. {learnMore}',
      postOnly:
        'Post-only 모드 활성화: 최근 체인 업그레이드에 따라 새로운 지정가 주문은 가능하지만, 시장가 주문과 즉시 매칭은 2000블록 동안 불가능합니다. {link}',
      settlePerpMarketBanner:
        '현재 이 마켓을 강제 정산하는 거버넌스 제안이 있습니다. 미결 포지션을 종료하는 것을 권장하며, 그렇지 않으면 정산 시점의 마크 가격으로 강제 청산됩니다.',
      settlePerpMarketBannerNewLaunch:
        '현재 WTI PERP 마켓을 강제 청산하기 위한 거버넌스 제안이 진행 중입니다. 오픈 포지션을 정리하는 것을 권장하며, 그렇지 않을 경우 청산 시점의 시장 평균가로 포지션이 강제 청산됩니다. 이 마켓이 청산된 후, 새로운 만기 선물 마켓이 출시될 예정입니다.',
      pointsS1Ended:
        'Helix 포인트 시즌 1이 종료되었습니다. 참여해 주셔서 감사하며, 더 많은 업데이트를 기대해 주세요!',
      expiryFuturesBanner:
        '이 거래쌍은 {date}에 결제되는 만기 선물입니다. 해당 시점 이후의 모든 미청산 포지션은 결제 시점의 마크 가격으로 강제 결제됩니다.',
      mkrExpiry:
        'MKR에서 SKY로의 전환 과정의 일환으로, 이 거래쌍은 9월 14일(거버넌스 승인 대기 중)에 강제 결제됩니다. 해당 날짜에 미청산된 모든 포지션은 결제 시점의 마크 가격으로 강제 결제됩니다.',
      kado: {
        getStarted: '시작하기',
        title: 'Helix 2.0 소개! 완전히 새로운 트레이딩 경험을 발견하세요.'
      },
      stocks: {
        description:
          '암호화폐로 주식을 거래하여 더 빠르고 저렴하며 투명한 거래를 경험하세요 - 전통적인 마켓과 탈중앙화 금융의 힘을 결합했습니다.'
      },
      userFeedback: {
        threeMinutes: '3분 ',
        notRightNow: '지금은 아니요',
        takeSurvey: '설문조사 참여',
        loveFeedback: '여러분의 피드백을 듣고 싶습니다!',
        thankYouEnd:
          '으로 완료되며, 이 정보는 Helix에서의 향후 경험을 개선하는 데 도움이 됩니다.',
        thankYouBeginning:
          'Helix를 사용해 주셔서 감사합니다. 저희는 사용자를 위해 지속적으로 제품을 개선하고 있으며 여러분의 의견을 듣고 싶습니다!'
      },
      newFeature: {
        cta: 'TradFi 거래',
        title: 'TradFi 주식 지수 소개!',
        description:
          '처음으로 하나의 통합된 지수를 통해 최대 규모의 상장 주식을 온체인에서 거래하세요. Helix에서만 최저 수수료와 최대 25배 레버리지로 24/7 TradFi에 액세스하세요.'
      },
      leaderboard: {
        currentCompetitionLink: '자세히 보기',
        currentCompetitionTitle:
          'Helix 트레이딩 캠페인에 참여하세요 — 총상금 $25,000, 진행 기간: 10월 9일–23일! {linkDescription}',
        gwagon: {
          title: 'Trade Like a G',
          description:
            'G-Wagon을 얻을 기회를 위해 거래하세요! 10월 1일 14:00 UTC부터 10월 22일 14:00 UTC까지, 2대의 G-Wagon 중 하나를 얻을 기회를 위해 거래하세요. 하나는 최고 PnL 트레이더에게, 다른 하나는 행운의 추첨 당첨자에게 제공됩니다. 10달러의 거래량마다 한 번의 참가 기회를 얻습니다. 자세한 내용은 {blog}를 방문하세요.'
        },
        tesla: {
          title: 'Tesla를 획득하세요!',
          description:
            'Tesla를 얻을 기회를 위해 거래하세요! 11월 26일 15:00 UTC부터 12월 6일 15:00 UTC까지, PnL 기준 상위 트레이더가 Tesla Model 3를 획득합니다. 자세한 내용은 {blog}를 방문하세요.'
        },
        ownYourAsset: {
          title: '자산을 소유하고, 미래를 통제하세요.',
          description:
            'Helix에서 $50K 상금 풀의 몫을 두고 경쟁하세요. 2025년 2월 21일 오후 6시 UTC부터 2025년 3월 3일 오후 6시 UTC까지, 무작위 추첨을 통해 $50k 상금 풀에서 $1,000을 얻을 기회를 위해 거래할 수 있습니다. $1,000의 거래량마다 한 번의 참가 기회를 얻습니다. 자세한 내용은 {blog}를 방문하세요'
        },
        volumeVictory: {
          title: '거래량이 곧 승리',
          description:
            'Everything Exchange에서 $1,000 거래할 때마다 $25,000 상금 풀에 더 가까워집니다.'
        }
      }
    },
    referral: {
      share: '공유',
      approve: '승인',
      referNow: '지금 추천',
      noReferrals: '추천 없음',
      referralLink: '추천 링크',
      referAndEarn: '추천하고 수익 얻기',
      confirmReferral: '추천 확인',
      referralDetails: '추천 세부사항',
      scanToJoin: 'Helix에 가입하려면 스캔하거나',
      yourReferralLink: '내 추천 링크',
      checkAvailability: '사용 가능 여부 확인',
      affiliatedAddress: '제휴 주소',
      startEarningToday: '오늘부터 수익 시작',
      createReferralLinkPlaceholder: 'BULLISH',
      customReferralCode: '맞춤 추천 코드',
      chooseDifferentLink: '다른 링크 선택',
      dashboardTitle: '트레이더를 추천하고 보상을 받으세요',
      referralLinkAvailable: '추천 링크 사용 가능!',
      lettersAndNumbersOnly: '문자와 숫자만',
      confirmAndGenerateLink: '확인 후 링크 생성',
      createReferralLinkTitle: '추천 링크 만들기',
      trackYourReferrals: '추천 현황과 수수료 수입을 추적하세요',
      shareYourReferralLink: '추천 링크를 공유하고 친구를 초대하세요.',
      referralCodeMaxLengthMessage: '추천 코드는 최대 32자까지 가능합니다',
      dashboardSubtitle:
        '사용자를 추천하여 보상을 받으세요. 어필리에이트는 더 큰 보상을 받습니다.',
      createReferralLinkSubtitle:
        '추천을 추적하는 데 사용될 고유한 링크를 선택하세요. 기억하기 쉽고 공유하기 쉽게 만드세요.',
      rewardsTooltipContent:
        '성공적인 추천으로부터 얻은 총 수수료입니다. 보상은 추천인의 거래 활동에 따라 적립됩니다.',
      referralLinkAvailableDescription:
        '추천 코드 {baseUrl}/ref/{referralCode}를 사용할 수 있습니다. 이 링크를 사용하시겠습니까?',
      confirmReferralDescription:
        '{baseUrl}/ref/{referralCode}로 추천받게 됩니다. 이 주소와 제휴하시겠습니까?',
      table: {
        wallets: '지갑',
        'join-date': '가입일',
        commission: '수수료'
      },
      myStats: {
        title: '내 통계',
        rewardsEarned: '획득한 보상',
        tradersReffered: '추천한 트레이더'
      },
      referFriends: {
        title: '친구 추천 방법',
        step3Title: '보상 자동 수령',
        step2Title: '친구 초대하고 40% 수익',
        step1Title: '추천 링크 공유',
        step2Description: '원하는 만큼 친구를 추가하세요.',
        description1: '네트워크를 Helix에서 거래하도록 초대하고',
        step1Description: '고유한 링크를 생성할 수 있습니다.',
        description2: ' 그들의 수수료의 40%를 수수료로 받으세요.',
        step3Description: '암호화폐 지갑으로 즉시 보상을 받으세요.'
      },
      shareModal: {
        title: '친구를 초대하세요!',
        customizeYourText: '텍스트 맞춤 설정',
        description: 'QR 코드를 스캔하고 Helix에서 저와 함께하세요!',
        defaultText:
          '보상을 추적하고 언제든지 출금하세요. 네트워크를 Helix에서 거래하도록 초대하고 그들의 수수료의 40%를 수수료로 받으세요.'
      }
    },
    lpRewards: {
      volume: '거래량',
      overall: '전체',
      address: '주소',
      rewards: '보상',
      ongoing: '진행중',
      title: 'LP 보상',
      letsGo: '시작해요!',
      round: '라운드 {round}',
      myRewards: '내 보상',
      allRewards: '전체 보상',
      estRewards: '예상 보상',
      totalVolume: '총 거래량',
      rewardStats: '보상 통계',
      addLiquidity: '유동성 추가',
      rewardsRound: '보상/라운드',
      campaignRules: '캠페인 규칙',
      rewardsDetails: '보상 세부사항',
      rewardsToClaim: '수령할 보상',
      volumeThisRound: '이번 라운드 거래량',
      lastUpdated: '마지막 업데이트: {date}',
      dashboardTitle: 'LP 보상 대시보드',
      myRewardsCount: '내 보상 ({rewards})',
      noActiveCampaigns: '활성 캠페인 없음',
      endTimeForRound: '라운드 {round} 종료 시간',
      totalRewardsAllTime: '총 보상 (전체 기간)',
      totalRewardsThisRound: '이번 라운드 총 보상',
      totalRewardsOfRound: '라운드 {round}의 총 보상',
      helixLpRewardsRound: 'Helix LP 보상 라운드 {round}',
      description: '다양한 현물 마켓에서 거래하여 보상을 받으세요',
      rewardsPending:
        'LP 보상 대기 중: 이 페어의 보상이 현재 처리 중입니다. 라운드 종료 후 최대 일주일까지 펀딩이 걸릴 수 있습니다.',
      legacyBotWarning:
        '경고: LP 보상을 놓치고 있습니다! 레거시 마켓 전략을 중단하고 새로운 마켓에서 새 전략을 만들어 보상을 받기 시작하세요.',
      roundIsLive:
        '{round1}이 시작되었습니다! 이번 라운드에 추가된 새로운 마켓을 확인해보세요! {round2}의 보상을 받으려면 페이지의 {myRewards}로 이동하세요.',
      table: {
        liquidity: {
          market: '마켓',
          volume: '거래량',
          rewards: '보상',
          'active-bots': '활성 봇'
        },
        dashboard: {
          market: '마켓',
          volume: '거래량',
          rewards: '보상',
          'est-rewards': '예상 보상'
        }
      }
    },
    portfolio: {
      swaps: '스왝',
      staked: '스테이킹됨',
      positions: '포지션',
      spotOrders: '현물 주문',
      assetsFrom: '자산 출처',
      totalValue: '총 가치',
      tradeHistory: '거래 내역',
      orderHistory: '주문 내역',
      noOpenOrders: '진행 중인 주문 없음',
      fundingHistory: '펀딩 내역',
      advancedOrders: '고급 주문',
      derivativeOrders: '파생상품 주문',
      noTransferHistory: '전송 내역이 없습니다',
      noFundingHistory: '펀딩 내역이 없습니다',
      showUnverifiedAssets: '미검증 자산 표시',
      notAvailableinAuthZOrAutoSignMode:
        '액세스 제어 모드 또는 자동 서명 모드에서는 사용할 수 없습니다',
      tab: {
        pnl: 'PNL',
        account: '계정'
      },
      home: {
        stakedInj: '스테이킹된 INJ',
        yieldBearingUsdt: '수익률 자산 USDT',
        unrealizedPositions: '미실현 포지션',
        volume: {
          title: '거래량 (주간)'
        },
        balance: {
          title: '포트폴리오 가치'
        },
        tradableBalance: {
          title: '거래 가능 가치'
        },
        pnl: {
          title: '트레이딩 PnL',
          tooltip:
            '포트폴리오 페이지의 손익 계산은 2024년 5월 29일 이후 Helix에서 개설 및 종료된 포지션의 대략적인 실현 손익을 반영합니다. 이 계산은 순전히 예시 목적이며 세금 신고 의무에 사용되어서는 안 됩니다.'
        }
      },
      balances: {
        netWorth: '순자산',
        transferToMain: '메인으로 전송'
      },
      subaccounts: {
        addSubaccountOrTransfer: '서브계정 추가 / 전송',
        accountEndBot:
          '메인 계정으로 자금을 전송하려면 현재 현물 Grid 트레이딩 봇을 중단해주세요. 이 작업으로 자금 전송이 자동으로 시작됩니다.',
        description:
          '이는 디지털 자산의 별도 관리 및 거래를 위해 메인 계정과 연결된 보조 계정입니다. 활성화하려면 먼저 자금을 전송해야 합니다. FAQ에서 서브계정에 대해 자세히 알아보세요.'
      },
      settings: {
        title: '설정',
        account: '계정',
        notAvailableinAuthZMode: '액세스 제어 모드에서는 사용할 수 없습니다',
        preferences: {
          title: '설정',
          eip712: {
            title: 'EIP-712 서명 활성화'
          },
          autosign: {
            description:
              '자동 서명을 사용하면 지갑에서 각 트랜잭션을 수동으로 승인할 필요 없이 거래할 수 있습니다',
            tooltip:
              '활성화되면 최대 3일 동안 각 트랜잭션에 서명할 필요가 없으며, 언제든지 다시 전환할 수 있습니다.'
          },
          thousandsSeparator: {
            title: '천 단위 구분자',
            description:
              '큰 숫자에 쉼표를 추가하여 읽기 쉽게 합니다. 예: 1234567 → 1,234,567'
          },
          gridTradingSubaccounts: {
            title: 'Grid 트레이딩 서브계정 표시',
            description: 'Grid 트레이딩 전용 서브계정 목록 표시'
          }
        }
      },
      filters: {
        byType: '유형별 필터',
        bySide: '사이드별 필터',
        byAsset: '자산별 필터',
        byMarket: '마켓별 필터',
        cleanFilters: '필터 지우기'
      },
      connectMobile: {
        grantAccess: '액세스 허용',
        scanCode: '계속하려면 코드 스캔',
        scanQRCode: '모바일에서 이 QR 코드를 스캔하여 지갑을 연결하세요'
      },
      bankTransfer: {
        title: '전송',
        enterAddress: 'Injective 주소 입력',
        doubleCheck:
          '주소를 확인해주세요. 잘못된 주소로 보낸 토큰은 복구할 수 없습니다.',
        memo: {
          title: '메모',
          required: '필수',
          placeholder: '메모 입력 (대부분의 중앙화 거래소에서 필수)'
        }
      },
      duration: {
        '1D': '1일',
        '1W': '1주',
        '1M': '1개월'
      },
      walletHistory: {
        subaccountDepositType: '지갑에서 서브계정으로',
        subaccountWithdrawalType: '서브계정에서 지갑으로',
        subaccountInternalTransferType: '서브계정에서 서브계정으로'
      },
      keyStats: {
        title: '주요 통계',
        allTimePnl: '전체 기간 PNL',
        totalVolume: '총 거래량',
        totalEquity: '총 자산',
        stakingAccount: '스테이킹 계정',
        spotAccountEquity: '현물 계정 자산',
        perpsAccountEquity: '무기한 계정 자산'
      },
      authZ: {
        title: '액세스 제어 관리',
        description:
          '다른 지갑 주소에 전체/부분 권한을 부여하여 대신 거래하도록 허용',
        revoke: '취소',
        actions: '작업',
        grantee: '피허용자',
        granter: '허용자',
        revokeAll: '전체 취소',
        connectAs: '다음으로 연결',
        noGrants: '권한이 없습니다',
        authZAs: '{address}로 AuthZ',
        granteeAddress: '피허용자 주소',
        grantedFunctions: '허용된 기능',
        connectMobile: '모바일 기기 연결',
        addNewGrantee: '새 피허용자 주소 추가',
        addGranteeAddress: '피허용자 주소 추가',
        viewGrantedFunctions: '허용된 기능 보기',
        notAvailableinAutoSignMode: '자동 서명 모드에서는 사용할 수 없습니다'
      },
      autoSign: {
        title: '자동 서명',
        durationDescription: '자동 서명이 3일간 활성화되었습니다.',
        pageTitle: '자동 서명: 트랜잭션 자동 승인',
        content1: {
          description1: '활성화되면 최대 3일 동안',
          description2:
            '각 트랜잭션에 서명하지 않고도 Helix를 사용할 수 있습니다.'
        },
        content2: {
          title: '다음 용도로 사용할 수 있습니다:',
          description1: '포지션 열기/닫기 (현물 및 무기한 페어)',
          description2: '지정가 주문 설정',
          description3: '익절매 / 손절매 (TP/SL) 주문 생성'
        },
        content3: {
          title: '참고:',
          description1: '스왑과 트레이딩 봇은 포함되지 않습니다.',
          description2: '보안을 위해 세션은 3일 후 자동으로 만료됩니다.',
          description3: '만료 후 언제든지 새 세션을 시작할 수 있습니다.'
        },
        expiredToast: {
          settings: '설정',
          title: '자동 서명 세션이 만료되었습니다',
          description: '{settings}에서 새 세션을 시작할 수 있습니다'
        }
      },
      table: {
        fundingHistory: {
          time: '시간',
          pair: '페어',
          payment: '지불'
        },
        subaccounts: {
          name: '서브계정명',
          address: '서브계정 주소',
          'total-usd': '총 가치 (USD)'
        },
        historySwap: {
          fee: '수수료',
          time: '시간',
          route: '경로',
          outgoing: '송금',
          incoming: '수신'
        },
        historyWallet: {
          time: '시간',
          type: '유형',
          asset: '자산',
          amount: '수량',
          origin: '출발지',
          destination: '목적지'
        },
        balance: {
          total: '총계',
          assets: '자산',
          staked: '스테이킹됨',
          available: '사용 가능',
          'staked-usd': '스테이킹됨 (USD)',
          'total-usd': '총 가치 (USD)',
          'unrealized-pnl': '미실현 PnL',
          'used-or-reserved': '사용 중/예약됨'
        },
        spotOpenOrder: {
          side: '사이드',
          price: '가격',
          chase: '추격',
          action: '작업',
          market: '마켓',
          amount: '수량',
          filled: '체결됨',
          unfilled: '미체결',
          'total-amount': '총 수량'
        },
        spotOrderHistory: {
          type: '유형',
          side: '사이드',
          price: '가격',
          total: '총액',
          status: '상태',
          market: '마켓',
          amount: '수량',
          'last-updated': '마지막 업데이트',
          'trigger-condition': '트리거 조건'
        },
        spotTradeHistory: {
          fee: '수수료',
          time: '시간',
          pair: '페어',
          type: '유형',
          side: '사이드',
          total: '총액',
          price: '가격',
          amount: '수량'
        },
        futuresOpenOrder: {
          side: '사이드',
          price: '가격',
          total: '총액',
          chase: '추격',
          action: '작업',
          market: '마켓',
          amount: '수량',
          filled: '체결됨',
          unfilled: '미체결',
          leverage: '레버리지'
        },
        futuresOrderHistory: {
          type: '유형',
          side: '사이드',
          price: '가격',
          total: '총액',
          status: '상태',
          market: '마켓',
          amount: '수량',
          'last-updated': '마지막 업데이트',
          'trigger-condition': '트리거 조건'
        },
        futuresTradeHistory: {
          fee: '수수료',
          time: '시간',
          type: '유형',
          side: '사이드',
          price: '가격',
          total: '총액',
          market: '마켓',
          amount: '수량',
          pnl: '종료 PNL'
        },
        futuresAdvancedOrders: {
          type: '유형',
          side: '사이드',
          price: '가격',
          total: '총액',
          action: '작업',
          market: '마켓',
          amount: '수량',
          leverage: '레버리지',
          'trigger-condition': '트리거 조건'
        },
        position: {
          side: '사이드',
          'tp-or-sl': 'TP/SL',
          market: '마켓',
          mark: '마크 가격',
          entry: '진입 가격',
          leverage: '레버리지',
          contracts: '계약',
          margin: '포지션 마진',
          'total-usd': '총 가치 (USD)',
          'liquidation-price': '청산 가격',
          'close-position': '포지션 종료',
          'unrealized-pnl': '미실현 PNL'
        }
      }
    },
    navigation: {
      spot: '현물',
      swap: '스왑',
      trade: '거래',
      swaps: '스왑',
      stocks: '주식',
      points: '포인트',
      orders: '주문',
      markets: '마켓',
      history: '내역',
      balances: '잔액',
      settings: '설정',
      portfolio: '포트폴리오',
      positions: '포지션',
      myAccount: '내 계정',
      disconnect: '연결 해제',
      derivative: '파생상품',
      noTierLevel: 'VIP 등급 없음',
      subaccounts: '서브계정',
      leaderboard: '리더보드',
      tradingBots: '트레이딩 봇',
      fundingHistory: '펀딩 내역',
      subaccountHistory: '서브계정 내역',
      makerTakerFee: '-{maker}% 메이커 / -{taker}% 테이커',
      more: {
        olp: 'OLP',
        title: '더보기',
        vaults: '볼트',
        bridge: '브릿지',
        deposit: '입금',
        referral: '추천',
        lpRewards: 'LP 보상'
      }
    },
    footer: {
      blog: '블로그',
      v2: ' 버전 2.0',
      support: '지원',
      docs: 'Helix 문서',
      explorer: '익스플로러',
      resources: '리소스',
      community: '커뮤니티',
      operational: '운영 상태',
      feeDiscounts: '수수료 할인',
      institutional: '기관',
      privacyPolicy: '개인정보 처리방침',
      apiDocumentation: 'API 문서',
      termsAndConditions: '이용약관',
      helixProvides:
        '참고: Helix는 Injective DAO의 승인에 따라 여러 마켓에서 메이커 리베이트를 제공할 수 있습니다.'
    },
    tradingBots: {
      all: '전체',
      time: '시간',
      user: '사용자',
      auto: '자동',
      lower: '하한',
      upper: '상한',
      active: '활성',
      manual: '수동',
      endBot: '봇 종료',
      removed: '제거됨',
      pending: '대기중',
      overview: '개요',
      showcase: '쇼케이스',
      duration: '기간',
      spotGrid: '현물 Grid',
      totalTvl: '총 TVL',
      totalPnl: '총 PnL',
      totalRoi: '총 ROI',
      moreInfo: '더 많은 정보',
      gridMode: 'Grid 모드',
      title: '더 스마트한 거래',
      available: '사용 가능',
      geometric: '기하급수',
      startTime: '시작 시간',
      gridBound: 'Grid 범위',
      investment: '투자',
      priceRange: '가격 범위',
      activeBots: '활성 봇',
      lowerPrice: '하한 가격',
      upperPrice: '상한 가격',
      lowerBound: '하한선',
      upperBound: '상한선',
      gridNumber: 'Grid 개수',
      stopReason: '중단 이유',
      futuresGrid: '선물 Grid',
      totalProfit: '총 수익',
      volumeBoost: '거래량 부스트',
      totalAmount: '총 금액',
      totalAssets: '총 자산',
      viewDetails: '세부사항 보기',
      profitGrid: 'Grid 간격',
      gridDetails: 'Grid 세부사항',
      assetsInBot: '봇 내 자산',
      currentPrice: '현재 가격',
      copyStrategy: '전략 복사',
      noActiveBots: '활성 봇 없음',
      enableLpMode: 'LP 모드 활성화',
      trailingBound: '추적 범위',
      setUpNewBot: '새 봇 설정',
      liquidityGrid: '유동성 Grid',
      topPerformers: '실시간 인기 전략 ',
      initialAmount: '초기 금액',
      numberOfGrids: 'Grid 개수',
      createStrategy: '전략 생성',
      enableTrailing: '추적 활성화',
      learnMoreHere: '여기서 자세히 알아보세요.',
      removeStrategy: '전략 제거',
      lowerPriceStop: '하한 가격 중단',
      upperPriceStop: '상한 가격 중단',
      saveOnFees: '입금 금액 조정',
      noStrategies: '전략이 없습니다.',
      optimizedAmounts: '최적화된 금액',
      totalBotsCreated: '생성된 총 봇 수',
      replicateStrategy: '전략 복사하기',
      buySymbolOnStop: '중단 시 {symbol} 매수',
      insufficientFunds: '자금 부족',
      approximateProfit: '대략적인 수익',
      initialEntryPrice: '초기 진입 가격',
      trailingPriceRange: '추적 가격 범위',
      createYourStrategy: '전략 생성',
      noActiveStrategies: '활성 전략 없음',
      keepOriginalAmounts: '원래 금액 유지',
      useFeeOptimizedAmounts: '제안된 금액 사용',
      sellAllSymbolOnStop: '중단 시 모든 {symbol} 매도',
      exceededMaxRetries: '변동성이 큰 마켓 상황',
      copyParametersToManual: '매개변수를 수동으로 복사',
      botCreationConfirmation: '봇 생성 확인',
      strategyRemovalInitiated: '전략 제거 시작됨',
      sellSymbolUponTermination: '종료 시 {symbol} 매도',
      marketConditionsNotSupported: '지원되지 않는 마켓 상황',
      minInvestmentDescription: "최소 투자: {symbols} ≥ {'$'}{amount}",
      youCanCloseThisNotification:
        '이 알림을 닫고 플랫폼을 계속 사용할 수 있습니다.',
      confirmationDescription:
        '계속 진행하기 전에 아래 정보를 주의깊게 읽어주세요.',
      autoModeHeader:
        '이 매개변수들은 지난 30일간의 거래 가격을 기반으로 자동 생성됩니다.',
      nOfGridsTooltip:
        '높은 Grid 개수는 더 많은 주문을 배치하여 가격 변동을 더 잘 포착하지만 더 많은 초기 자본이 필요합니다.',
      yourTradingStrategyIsBeingRemoved:
        '귀하의 트레이딩 전략이 제거되고 있으며 자동으로 완료됩니다. 이 과정은 몇 분 정도 소요될 수 있습니다.',
      disclaimer:
        '위험 고지사항을 읽고 동의했으며, 매개변수 선택과 투자 결정은 모든 경우에 고객이 단독으로 내린다는 것을 이해합니다.',
      description:
        'Helix의 자동화 거래를 위한 명령 센터입니다. 활성 봇을 모니터링하고, LP 보상을 추적하며, 다음 움직임을 위한 고성능 커뮤니티 전략을 발견하세요.',
      topPerformersDescription:
        '지금 Helix에서 가장 높은 수익률을 기록 중인 전략과 설정을 확인하세요. 성공 데이터를 참고해 내 전략을 개선하거나, 검증된 결과를 바탕으로 새 봇을 시작해보세요.',
      botType: {
        spotGrid: '현물 Grid',
        futuresGrid: '선물 Grid',
        liquidityGrid: '거래량 부스트'
      },
      myLpRewards: {
        viewAll: '전체 보기',
        title: '내 LP 보상',
        volumeAllTime: '총 거래량',
        rewardsAllTime: '총 LP 보상',
        volumeThisRound: '이번 라운드 거래량',
        totalEstRewards: '총 예상 보상',
        roundEndTime: '라운드 {round} 종료 시간'
      },
      sgt: {
        lpModeTooltip:
          'LP 모드가 활성화되면 전략은 설정 중 리밸런싱을 피하고 비대칭 매수 및 매도 주문을 생성하여 유동성 공급자의 행동을 복제합니다.',
        lowerPriceStopTooltip:
          "Grid가 새로운 매수 주문 생성을 중단할 가격을 정의합니다. 이는 포지션을 종료하는 전통적인 '손절매'가 아니라 원하는 Grid 범위 외에서 매수 활동을 일시 중단하는 조건입니다.",
        upperPriceStopTooltip:
          'Grid가 새로운 매도 주문 생성을 중단할 가격을 설정합니다. 이는 활성 Grid 매도의 상한선 역할을 하며, 가격이 정의된 범위를 초과할 때 활동을 일시 중단합니다.',
        minInvestmentTooltip:
          "최소 투자: {'$'}{amount}부터 시작합니다. 10개를 초과하는 각 Grid마다 최대 100개 Grid까지 $5가 추가됩니다. 금액은 {assets} 자산의 $ 가치로 계산됩니다.",
        balancedFeesMessage:
          '귀하의 입금 가치는 {initialInvestment} USD입니다. 제공된 가격 범위와 Grid 개수를 기반으로, 각 자산의 제안 금액은 {quoteAmount} {quote}와 {baseAmount} {base}입니다. 제안된 입금 금액은 봇이 초기에 생성할 매수 및 매도 주문을 기반으로 하며, 제공한 원래 입금 금액과 동일한 가치를 유지합니다.',
        investmentTooltip:
          'USDT & INJ 조합으로 밸런싱 전략 수수료를 줄이세요. 이는 새로운 플랫폼 수수료가 아니라 전략 생성 시 견적 및 기본 디노미네이션 간 변환 시 가스 비용을 절약하는 방법입니다.',
        gridModeTooltip:
          '산술 모드에서는 연속된 두 Grid 간의 가격이 일정한 차이를 갖습니다. 기하 모드에서는 연속된 두 Grid 간의 가격이 일정한 비율을 갖습니다.',
        tabs: {
          liveSpotGrid: '라이브 현물 Grid',
          spotGridHistory: '현물 Grid 내역',
          liveFuturesGrid: '라이브 선물 Grid',
          futuresGridHistory: '선물 Grid 내역'
        },
        modes: {
          perpetual: '무기한',
          geometric: '기하급수',
          arithmetic: '산술',
          arithmetic_lp: '산술 LP',
          trailing_arithmetic: '추적 산술',
          trailing_arithmetic_lp: '추적 산술 LP'
        },
        optimization: {
          optimizeBalance: '잔액 최적화',
          balanceOptimized: '최적 잔액',
          balanceStability: '잔액 안정성',
          confirmAndAdjust: '확인 및 조정',
          balanceNeedsAdjusting: '잔액 조정 필요',
          optimizeBalanceTitle: '전략 잔액 최적화',
          adjustYourAvailableBalance:
            '사용 가능한 [{base}] 및 [{quote}] 잔액을 조정하세요',
          yourBalanceIsOptimal:
            '가격 범위 내에서 최대 Grid 효율성을 위해 잘 균형잡혀 있습니다',
          yourBalanceIsOffBy:
            '귀하의 잔액이 최적의 50/50 비율에서 {percentage}% 벗어나 있습니다.',
          balancedTooltip:
            '잔액 안정성은 귀하의 유동성 포지션이 토큰 간의 의도된 비율을 얼마나 잘 유지하는지를 나타냅니다. 높은 백분율은 귀하의 포지션이 시장 변동성에 더 저항력이 있고 리밸런싱이 덜 빈번하게 필요함을 의미합니다.',
          optimizeBalanceBody:
            '거래 수수료를 줄이고 운영 효율성을 개선하기 위해 자산 리밸런싱을 제안합니다. 이 기술적 조정은 전략이 거래를 실행하는 방식을 최적화하지만, 자산 선택이나 예상 수익에 대한 금융 조언은 아닙니다.'
        }
      },
      liquidityBots: {
        title: '거래량 부스트 봇',
        description:
          '거래량을 손쉽게 부스트하세요. 거래량 부스트 봇은 유동성 공급을 자동화하여 지정된 범위 내에서 거래를 실행하고 기회를 포착하며 시장 존재감을 유지합니다.',
        deposit: '입금',
        passive: '수동적',
        moderate: '중간',
        duration: '기간',
        createBot: '봇 생성',
        aggressive: '공격적',
        selectPair: '페어 선택',
        timeCreated: '생성 시간',
        finalBalance: '최종 잔액',
        depositAmount: '입금 금액',
        trailingUpper: '추적 상한',
        trailingLower: '추적 하한',
        currentBalance: '현재 잔액',
        setLiquidityBot: '유동성 봇 설정',
        volatilityStrategy: '변동성 전략',
        trailingBoundaries: '추적 경계',
        upToRewards: '주간 최대 {amount} {symbol} 보상',
        depositDescription: '단일 자산으로 유동성을 추가할 수 있습니다'
      }
    },
    leaderboard: {
      myStats: '내 통계',
      title: '리더보드',
      viewMore: '더보기',
      helix: 'helixapp.com',
      timestamp: '타임스탬프',
      startTrading: '트레이딩 시작',
      privacyPolicy: '개인정보 처리방침',
      rulesTermsAndConditions: '규칙, 이용약관',
      refresh: '리더보드는 매시 정각에 새로고침됩니다',
      description:
        'Helix는 온체인 거래 을 기준으로 상위 트레이더를 순위를 매깁니다',
      tradeAndWin:
        '아직 리더보드에 없으신가요? Helix에서 수익성 있는 거래를 하여 자리를 차지하세요!',
      blocked:
        '미국, 영국 및 대회 공식 {terms}에 나열된 기타 특정 국가의 거주자는 대회에 참여하거나 우승할 자격이 없습니다.',
      tabs: {
        leaderboard: 'PnL 리더보드',
        'leaderboard-competition': '트레이딩 대회',
        'leaderboard-past-competitions': '과거 대회'
      },
      pnl: {
        share: '공유',
        tradingPnl: '트레이딩 PnL',
        noPnlData: 'PnL 결과가 없습니다',
        allTime: '2024년 8월 1일 00:00 UTC부터',
        currentDuration: '트레이딩 PnL ({duration})',
        lastUpdated: '마지막 업데이트: {lastUpdatedDate}',
        timePeriod: '기간: {startDate} - {endDate}',
        duration: {
          '1D': '오늘',
          ALL: '전체 기간',
          '1W': '이번 주',
          '1M': '이번 달'
        }
      },
      competition: {
        winner: '우승자',
        unranked: '순위 없음',
        currentLeaderFlame: '🔥',
        keepGoing: '계속 화이팅 💪',
        tradingVolume: '거래량',
        currentLeader: '현재 선두',
        competitionDuration: '남은 시간: {duration}',
        noVolumeData: '트레이딩 대회 결과가 없습니다',
        rulesTermsAndConditionsApply: '규칙, 약관 및 조건이 적용됩니다',
        checkBackLater: '당첨 여부를 확인하려면 나중에 다시 확인해주세요!',
        competitionBeginning: '대회가 곧 시작됩니다...',
        noPastCompetition: '현재 과거 대회가 없습니다.',
        thanksForParticipating:
          '참여해 주셔서 감사합니다! 안타깝게도 이번에는 당첨되지 않았습니다.',
        noCompetition: '현재 활성 대회가 없습니다. 나중에 다시 확인해주세요!',
        firstHourOfCampaign:
          '대회가 시작되었습니다. 리더보드는 {afterFirstHour}에 캠페인 통계를 표시하기 시작합니다.',
        additionalEntriesTooltip:
          '이는 대회 중 하나 이상의 보너스 기간에 참여하여 얻은 보너스 참가 기회입니다.',
        winnerModal: {
          emailPlaceholder: '이메일 주소',
          namePlaceholder: '이름과 성',
          bannerDescription:
            '축하합니다! 리더보드 대회에서 {prize} 에 당첨되셨습니다. 지금 클릭하여 상품 수령을 시작하세요!',
          getStarted: {
            cta: '시작하기',
            title: '축하합니다!',
            description:
              '{competition} 의 당첨자 중 한 명으로 선정되셨습니다! {prize} 을 받기 위해 추가 정보를 입력해 주세요.'
          },
          contactInfo: {
            cta: '확인',
            title: '연락처 정보 필요',
            description:
              '대회의 공식 {terms} 을 준수하기 위해, 본인 확인 및 상품 전달을 위한 연락처 정보를 제공해 주세요. 아래를 클릭하여 {privacyPolicy}에 동의해 주세요.'
          }
        }
      },
      header: {
        rank: '순위',
        entries: '참가 횟수',
        address: '주소',
        weeklyROI: '주간 ROI',
        volume: '거래량 (USD)',
        tradingPnl: '트레이딩 PnL (USD)',
        numberOfEntries: '참가 횟수',
        allMarketsVolume: '전체 마켓 거래량 (USD)'
      },
      footer: {
        onlyTop100Connect: '통계를 보려면 지갑을 연결하세요.',
        onlyTop100: '리더보드는 상위 100명의 참가자만 표시합니다.'
      }
    },
    maintenance: {
      title: '예정된 유지보수',
      governance: '거버넌스 제안',
      subscribe: '알림 구독',
      subscribeDescription: 'Notifi를 통해 실시간 알림 받기',
      governanceDescription: '최신 체인 업그레이드에 대한 세부사항 확인',
      footer:
        'Helix를 더 좋게 만들고 있습니다. 양해해 주셔서 감사하며 곧 돌아오겠습니다!',
      description:
        '몇 가지 업데이트를 진행하고 있습니다. 이 시간 동안 일부 기능을 잠시 사용할 수 없습니다.'
    },
    feeDiscounts: {
      off: '없음',
      tier: '등급',
      maker: '메이커',
      taker: '테이커',
      myFeeTier: '내 수수료 등급',
      currentApr: '현재 APR',
      pageTitle: '수수료 할인',
      updateDaily: '매일 업데이트',
      stakedAmount: '스테이킹 금액',
      tradingVolume: '거래량',
      myStakedAmount: '스테이킹 금액',
      lastUpdatedAt: '마지막 업데이트',
      inPastDays: '지난 {days}일간',
      myTradingVolume: '내 거래량',
      viewFeeDiscounts: '수수료 할인 보기',
      feesTakerMaker: '수수료 (테이커 / 메이커)',
      makerRateDiscount: '메이커 수수료율 할인',
      takerRateDiscount: '테이커 수수료율 할인',
      feesTakerMakerPercent: '{takerFee}% / {makerFee}%',
      makerRateDiscountTooltip: '수수료 등급에 따른 메이커 수수료 할인.',
      takerRateDiscountTooltip: '수수료 등급에 따른 테이커 수수료 할인.',
      pageDescriptionWarning:
        '메이커 수수료 할인은 음수가 아닌 메이커 수수료가 있는 마켓에만 적용됩니다.',
      pageDescription:
        '거래 수수료는 사용자의 INJ 스테이킹 금액과 지난 28일간의 총 거래량을 기준으로 합니다.',
      tradingVolumeTooltip:
        '28일 롤링 기준으로 거래된 총 거래량. 현재는 USD 견적 디노미네이션의 마켓만 포함됩니다.',
      stakedAmountTooltip:
        '스테이킹이 필요한 INJ 금액. INJ 스테이킹은 프로토콜을 보호하고, 보상을 받으며, 더 유리한 수수료 등급을 얻는 데 도움이 될 수 있습니다.'
    },
    tradeAndEarn: {
      title: 'Trade & Earn',
      description:
        '현물 및 무기한 거래 페이지에서 거래하거나 트레이딩 봇을 사용하여 INJ를 획득하세요',
      pts: '포인트',
      stakeMore: '더 스테이킹',
      makerPoints: '메이커 포인트',
      takerPoints: '테이커 포인트',
      estRewards: '예상 보상',
      campaignAsOf: '{date} 기준',
      estRewardsStake: '예상 보상',
      pendingRewards: '대기 중인 보상',
      emptyPendingRewards: '대기 중인 보상이 없습니다.',
      pendingMaxCampaignRewards: '총 할당 보상',
      myRewardPoints: '내 보상 포인트 / 총 보상 포인트',
      stakeTotalToReceiveFullAmount:
        '전체 금액을 받으려면 총 {total} INJ를 스테이킹하세요',
      sunset:
        'Trade & Earn에 참여해 주셔서 감사합니다! Helix 사용자에게 보상을 제공하도록 설계된 향후 프로그램을 기대해 주세요.',
      pendingMaxCampaignRewardsTooltip:
        '이전 에포크에서 배포된 총 INJ 수입니다. 보상 배포는 베스팅 기간 종료 시에 이루어집니다.',
      myRewardPointsTooltip:
        '이번 캠페인에서 획득한 현재 보상 포인트와 캠페인의 총 보상 포인트입니다. 보상 포인트는 다음 캠페인 시작 시 0으로 재설정됩니다.',
      estRewardsStakeTooltip:
        '보상 포인트 / 총 보상 포인트 * 총 할당 보상을 기반으로 이 주소에 배포될 예상 보상입니다. 이는 캠페인 종료까지 보상 포인트가 총 보상 포인트만큼 빠르게 증가한다고 가정하여 계산됩니다. 보상을 유지하거나 극대화하려면 캠페인이 끝날 때까지 동일하거나 더 높은 거래 활동을 유지해야 합니다. 보상 금액은 {maxRewards} INJ 또는 스테이킹된 INJ의 동등 금액 중 높은 것으로 제한됩니다'
    },
    institutional: {
      benefits: '혜택',
      talkToUs: '문의하세요.',
      modalTitle: '연락하기',
      getInTouch: '연락하기',
      learnMore: '더 알아볼 준비가 되셨나요?',
      trustedByTheBest: '최고의 신뢰를 받는',
      heroTitle: '진정한 온체인 기관 금융',
      allRightsReserved: 'Injective Labs. All Rights Reserved.',
      modalDescription: 'Helix 기관 팀과 직접 연결하세요.',
      whyFinancialInstitutionsChooseHelix: '금융 기관이 Helix를 선택하는 이유',
      heroSubtitle:
        '유일한 완전 탈중앙화 네트워크에서 무제한 암호화폐 자산, 무기한 계약 및 구조화 상품과 거래하세요.',
      permisionedMarketsTitle: '허가된 마켓',
      permisionedMarketsBody:
        'Helix는 기관급 허가 마켓에 대한 게이트웨이를 독특하게 제공하여 전문적으로 검증된 거래 상대방과 원활하게 상호작용할 수 있게 합니다.',
      multiAssetSupportTitle: '다중 자산 지원',
      multiAssetSupportBody:
        '여러 블록체인 네트워크에 걸쳐 다양한 온체인 자산, 파생상품 및 구조화 상품에 액세스하세요.',
      onChainTransparencyTitle: '온체인 투명성',
      onChainTransparencyBody:
        '모든 거래, 트레이딩, 정산 및 자산 발행이 완전히 온체인에서 발생하는 유일한 플랫폼으로 보안을 극대화하세요.',
      fullyCompliantTitle: '온체인 투명성',
      fullyCompliantBody:
        '모든 거래, 트레이딩, 정산 및 자산 발행이 완전히 온체인에서 발생하는 유일한 플랫폼으로 보안을 극대화하세요.',
      instantSettlementTitle: '즉시 정산',
      instantSettlementBody:
        '업계에서 가장 빠른 정산 시간으로 조작 방지되는 MEV 저항 트랜잭션을 실행하세요.',
      robustSecurityTitle: '강력한 보안',
      robustSecurityBody:
        '자산이 절대 통제권을 벗어나지 않도록 보장하는 가장 엄격한 보안 조치를 갖춘 비수탁 플랫폼을 활용하세요.',
      superiorInfrastructureTitle: '우수한 인프라',
      superiorInfrastructureBody:
        '가장 정교한 금융 기관과 트레이더의 요구에 맞게 설계된 Helix의 맞춤형 인프라를 활용하세요.',
      form: {
        email: '이메일',
        company: '회사',
        lastName: '성',
        firstName: '이름'
      }
    },
    common: {
      or: '또는',
      and: '및',
      pnl: 'PnL',
      max: '최대',
      docs: '문서',
      back: '뒤로',
      base: '기본',
      blog: '블로그',
      ended: '종료됨',
      copy: '복사',
      here: '여기',
      link: '링크',
      view: '보기',
      total: '총계',
      quote: '견적',
      value: '가치',
      close: '닫기',
      ready: '준비됨',
      claim: '수령',
      amount: '금액',
      enable: '활성화',
      submit: '제출',
      search: '검색',
      cancel: '취소',
      sortBy: '정렬 기준',
      connect: '연결',
      details: '세부사항',
      runtime: '런타임',
      claimed: '수령됨',
      deposit: '입금',
      confirm: '확인',
      disabled: '비활성화됨',
      inactive: '비활성',
      transfer: '전송',
      withdraw: '출금',
      tradeNow: '지금 거래',
      active: '활성',
      noItems: '표시할 항목이 없습니다',
      download: '다운로드',
      ascending: '오름차순',
      learnMore: '더 알아보기',
      descending: '내림차순',
      tradingDocs: '트레이딩 문서',
      unauthorized: '승인되지 않음',
      baseAndQuote: '기본 및 견적',
      sortDirection: '정렬 방향',
      dontShowAgain: '다시 표시하지 않음',
      showMoreContext: '더 많은 맥락 보기',
      acknowledgeTerms: '약관 동의',
      pagination: '{from}에서 {to}까지 총 {totalCount}',
      day: '일',
      hour: '시간',
      minute: '분',
      second: '초',
      account: {
        main: '메인',
        subaccount: '서브계정',
        mainSubaccount: '메인 서브계정',
        subaccountId: '서브계정 {subaccountId}',
        subaccountTransfer: '서브계정 전송',
        noAssetToTransfer: '이 서브계정에서 전송할 자산이 없습니다.'
      },
      modal: {
        terms: {
          privacyPolicy: '개인정보 처리방침',
          termsAndCondition: '이용약관',
          title: '또한 귀하는 다음과 같이 진술, 보증 및 동의합니다:',
          acknowledge_1:
            '귀하는 미국(무기한 계약 거래와 관련하여), 영국(투자 전문가가 아닌 경우) 또는 제한 지역(Helix 이용약관에 정의된 대로)에 거주하거나 소재하거나 법인 설립되거나 등록된 대리인을 둔 개인 또는 회사가 아닙니다.',
          acknowledge_2:
            '귀하는 미국(무기한 계약 거래와 관련하여), 영국(투자 전문가가 아닌 경우) 또는 제한 지역(Helix 이용약관에 정의된 대로)에 위치하는 동안 현재 또는 향후에 이 사이트에 액세스하거나 helixapp.com을 사용하지 않을 것입니다.',
          acknowledge_3:
            '귀하는 제한 지역에서의 물리적 위치를 마스킹하기 위해 가상 사설망 또는 기타 수단을 사용하지 않고 있으며 향후에도 사용하지 않을 것입니다.',
          acknowledge_4:
            '귀하는 거주하고 있는 관할권의 법률에 따라 이 사이트에 액세스하고 helixapp.com에서 거래할 법적 허가를 받았습니다.',
          acknowledge_5:
            '귀하는 레버리지 사용, 무기한 계약 체결 및 디지털 자산 거래와 관련된 위험을 이해합니다.',
          disclaimerNote:
            '지갑에 연결함으로써 귀하는 Helix {0}와 Injective Labs {1}를 모두 읽었고, 동의하며, 구속받는다는 것을 인정합니다.'
        },
        postOnlyMode: {
          title: 'Post Only 모드!',
          description:
            'Injective Volan 메인넷 업그레이드 직후 2000블록(~30분) 동안은 이 기간에 지정가 주문만 배치할 수 있습니다.'
        },
        geoRestricted: {
          cta: '알겠습니다',
          title: 'Helix는 귀하의 지역에서 이용할 수 없습니다.',
          description:
            '규제 요구사항으로 인해 귀하의 지역에서 Helix를 제공할 수 없습니다. 저희 팀은 현지 법률을 완전히 준수하면서 서비스 지역을 확대하기 위해 적극적으로 노력하고 있습니다. 관심을 가져주셔서 감사하며 곧 성장하는 글로벌 커뮤니티에 여러분을 환영할 수 있기를 바랍니다. 미결 포지션이 있으시면 포트폴리오 페이지에서 종료하실 수 있습니다.'
        },
        devMode: {
          connect: '연결',
          enterPrivateKey: '개인 키를 입력하세요',
          connectWithPrivateKey: '개인 키로 연결',
          enterInjectiveAddress: 'Injective 주소를 입력하세요'
        },
        ninjaPass: {
          later: '나중에',
          verifyNow: '지금 확인',
          congratulations: '축하합니다! 🎉',
          title: '독점 Ninja Pass를 받으셨습니다 🥷',
          description:
            '이는 독점적인 Injective 이벤트, 제품, 경품 및 더 많은 놀라움에 대한 게이트웨이 역할을 할 것입니다.'
        },
        onboarding: {
          buyInjWithCard: '카드로 INJ 구매',
          injectiveBridge: 'Injective 브릿지',
          processing: '전송 처리 중',
          closeAndContinue: '닫고 계속',
          success: '거래가 확인되었습니다',
          depositUsdtFromEthereum: '이더리움에서 USDT 입금',
          processingMessage:
            '처리가 평소보다 오래 걸리고 있습니다. 잠시만 기다려주세요.',
          processingMessageInfo:
            '전송이 백그라운드에서 처리되고 있으며 이 모달을 안전하게 닫을 수 있습니다. 잔액 페이지에서 브릿지된 금액을 확인하거나 브릿지 내역을 확인할 수 있습니다 '
        }
      }
    },
    notFound404: {
      title: '페이지를 찾을 수 없음',
      backToHome: '홈페이지로 돌아가기',
      description: '찾고 계시는 페이지가 존재하지 않습니다.'
    }
  }
})
